import { render } from "./TheResetPasswordSuccessful.vue?vue&type=template&id=47c7284e&scoped=true&ts=true"
import script from "./TheResetPasswordSuccessful.vue?vue&type=script&lang=ts"
export * from "./TheResetPasswordSuccessful.vue?vue&type=script&lang=ts"

import "./TheResetPasswordSuccessful.vue?vue&type=style&index=0&id=47c7284e&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47c7284e"]])

export default __exports__